import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import { formatAmount, formatPhone } from '@/lib/utils/formatters'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, formatDate, applicantLink, statusLabel } from '../../utils/configuredReportFormatters'

export const approvedNotPurchasedColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] =
  [
    {
      id: 'property_name',
      label: 'Property',
      sortKey: 'property_name',
      render: (row) => display(row.property_name),
    },
    {
      id: 'applicant_id',
      label: 'Applicant ID',
      sortKey: 'applicant_id',
      render: (row) => applicantLink(row.applicant_id),
    },
    {
      id: 'applicant_name',
      label: 'Applicant Name',
      sortKey: 'applicant_name',
      render: (row) => display(row.applicant_name ?? row.name),
    },
    {
      id: 'email',
      label: 'Email',
      sortKey: 'email',
      render: (row) => display(row.email),
    },
    {
      id: 'mobile',
      label: 'Mobile',
      sortKey: 'mobile_no',
      render: (row) =>
        formatPhone(String(row.mobile ?? row.mobile_no ?? '')) || '—',
    },
    {
      id: 'rent_amount',
      label: 'Rent Amount',
      sortKey: 'rent_amount',
      render: (row) => formatAmount(row.rent_amount as string | number),
    },
    {
      id: 'lease_start_date',
      label: 'Move-in Date',
      sortKey: 'lease_start_date',
      render: (row) => formatDate(row.lease_start_date),
    },
    {
      id: 'status',
      label: 'Status - Progress',
      sortKey: 'applicant_status',
      render: (row) =>
        `${statusLabel(row.applicant_status)} - ${display(row.progress_status)}`,
    },
  ]
